import { render, staticRenderFns } from "./yongyao.vue?vue&type=template&id=6c397ed0&"
import script from "./yongyao.vue?vue&type=script&lang=ts&"
export * from "./yongyao.vue?vue&type=script&lang=ts&"
import style0 from "./yongyao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports